class PasswordToggle {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="PasswordToggle"]'),
      btn: module => module.querySelector('[data-child-module="PasswordToggle__Btn"]'),
      btnBody: module => module.querySelectorAll('[data-child-module="PasswordToggle__BtnBody"]')
    };
  }

  toggle(module) {
    const passwordElement = module.querySelector(`input`);
    if (!passwordElement) return;

    passwordElement.type = passwordElement.type === 'text' ? 'password' : 'text';
    this.config.btnBody(module).forEach(btnBodyElement_ => {
      const btnBodyElement = btnBodyElement_;
      if (btnBodyElement.style.display === 'none') btnBodyElement.removeAttribute('style');
      else btnBodyElement.style.display = 'none';
    });
  }

  addEventListeners(module) {
    const { btn } = this.config;
    const btnModule = btn(module);

    if (!btnModule) return;

    btnModule.addEventListener('click', () => {
      this.toggle(module);
    });
  }

  init() {
    const { moduleList } = this.config;

    moduleList().forEach(_module => {
      const module = _module;
      const { initialized } = module.dataset;

      if (initialized) return;
      module.dataset.initialized = true;

      this.addEventListeners(module);
    });
  }
}

export default PasswordToggle;
